export default __webpack_public_path__ + "04ee52f810fea5bb1966278771426b8d.png";